import { Image as rImage } from "react-native";
import { createThemedComponent } from "../css/create-themed-component";
export var Image = createThemedComponent(rImage);
